<template>
  <div class="classBox classInfo" v-if="!isloading">
    <BackBannerInfo
      @goBack="goBack"
      :defaultGoBack="true"
      :barOpacity="barOpacity"
      :isFixed="true"
      v-if="backBannerShow"
      title="详情"
    />
    <div
      v-if="detail_id == ''"
      :class="[
        'classInfo noneData',
        detail.pic_path == '' ? 'classInfo-navbar' : '',
        detail.pic_path == '' && not_iphonex ? 'classInfo-notiphonex' : '',
        detail.pic_path == '' && iphonex && !not_iphonex
          ? 'classInfo-iphonex'
          : '',
      ]"
    >
      <img :src="none" />
      当前课程已下线，去看看其他课程吧～
    </div>
    <div
      v-else
      :class="[
        'classInfo',
        detail.pic_path == '' ? 'classInfo-navbar' : '',
        detail.pic_path == '' && not_iphonex ? 'classInfo-notiphonex' : '',
        detail.pic_path == '' && iphonex && !not_iphonex
          ? 'classInfo-iphonex'
          : '',
      ]"
      ref="viewBox"
    >
      <van-icon
        v-if="detail.pic_path"
        class="iconBack"
        @click="goBack"
        name="arrow-left"
      />
      <img v-if="detail.pic_path" :src="detail.pic_path" class="picPath" />
      <div class="introduce">
        <div class="title detail-title">
          <div class="titleCon">
            <span v-if="detail.subject_name">
              【{{ detail.subject_name }}】
            </span>
            {{ detail.title }}
          </div>
        </div>
        <div class="subtitle" v-if="detail.subtitle">{{ detail.subtitle }}</div>
        <div class="tags" v-if="detail && detail.tags.length > 0">
          <p :class="{ 'tags-online': detail.teach_mode === 1 }">
            {{ detail.course_type_text }}
          </p>
          <div class="tagsli" v-for="(item, index) in detail.tags" :key="index">
            {{ item }}
          </div>
        </div>
        <div class="openTime">
          <span v-if="detail.start_time_text && detail.end_time_text">
            {{ detail.start_time_text }}-{{ detail.end_time_text }}<i />定制课时
          </span>
          <span v-else>定制课时<i />预约开课</span>
        </div>
        <!-- <div class="address" v-if="detail.school_address">
          {{ detail.school_address }}
        </div> -->
        <div
          class="qrcode"
          v-if="detail && detail.qrcode_path && detail.qrcode_path.name"
        >
          <div class="qrcodeItem">
            <img :src="qrcodeImg" />
            <div>
              <div class="title">添加老师微信</div>
              <span>领取专属学习资料</span>
            </div>
          </div>
          <div class="btnQrcode" @click="openQrcode()">去添加</div>
        </div>
      </div>
      <div class="service" @click="serviceShowFn">
        <span>服务</span>
        <span>{{ detail.service_title }}</span>
      </div>
      <div class="content-title" v-if="detail.content">课程详情</div>
      <div class="content" v-if="detail.content" id="h5MainPage"></div>
    </div>
    <div class="actionBar" v-if="detail.id">
      <a href="tel:400-012-1121" class="callTel">
        <i></i>
        <span>电话客服</span>
      </a>
      <div class="line"></div>
      <div class="barRight">
        <div class="btnYuyue" @click="openYuyue()">
          <i></i>
          <span>立即预约</span>
        </div>
      </div>
    </div>
    <van-popup
      v-model="showQrcode"
      round
      position="bottom"
      closeable
      :close-icon="iconClose"
    >
      <div class="popupQrcode" v-if="detail">
        <div class="title">添加学习顾问微信</div>
        <div class="subTitle">1对1学习规划指导</div>
        <div class="qrcodeWeixin">
          <img
            :src="detail && detail.qrcode_path && detail.qrcode_path.pic_path"
          />
        </div>
        <div class="msg">点击下方按钮即可领取</div>
        <div class="btnWeixin" @click="save()">保存二维码到相册</div>
      </div>
    </van-popup>
    <van-popup
      v-model="showYuyue"
      round
      position="bottom"
      closeable
      :close-icon="iconClose"
    >
      <div class="popupYuyue" v-if="detail">
        <div class="tips" v-if="detail.tip">{{ detail.tip }}</div>
        <div class="title">
          <i>{{ detail.course_type_text }}</i>
          <div class="titleCon">{{ detail.title }}</div>
        </div>
        <div class="classtime">自{{ start_time }}起·{{ detail.period }}</div>
        <div class="addressItem">
          <div v-if="detail.school_id" class="value">
            {{ detail.school_name }}
            <p>{{ detail.school_address }}</p>
          </div>
          <div v-else class="value">
            当前课程暂无配置校区
            <p>点击修改，选择合适的校区吧</p>
          </div>
          <div class="btnCity" @click="editSchool()">
            <span>修改校区</span>
            <i></i>
          </div>
        </div>
        <div class="btnWeixin" @click="add()">立即预约</div>
      </div>
    </van-popup>
    <ServicePopup
      v-if="detail.service_list && detail.service_list.length > 0"
      :serviceShow.sync="serviceShow"
      :serviceList="detail.service_list || []"
    />
  </div>
</template>
<script>
import { mapMutations } from "vuex";
import {
  formatDate,
  imageMogr2,
  loadStyle,
  loadScript,
  bury,
} from "../../utils/utils";
import BackBannerInfo from "@/components/backBannerInfo";
import ServicePopup from "./components/servicePopup";
import appUtil from "@/utils/appUtil";
import getToken from "@/utils/getToken";
import dayjs from "dayjs";
const parmas = {
  page_name: "课程详情页",
  event_name: "立即预约",
  event_type: "click",
};
export default {
  data() {
    return {
      backBannerShow: false,
      barOpacity: 0,
      not_iphonex: window.navigator.userAgent.includes("not_iphonex"),
      iphonex: window.navigator.userAgent.includes("iphonex"),
      isloading: true,
      isClick: true,
      showYuyue: false,
      showQrcode: false,
      qrcodeImg: require("../../assets/img/class/iconTeacher.png"),
      iconClose: require("../../assets/img/close.png"),
      none: require("../../assets/img/class/blankpage_jiangyi.png"),
      detail_id: "",
      detail: "",
      // detailTime: "",
      start_time: "",
      serviceShow: false,
    };
  },
  components: { BackBannerInfo, ServicePopup },
  created() {
    let width =
      document.documentElement.clientWidth || document.body.clientWidth;
    document.documentElement.style.fontSize = width / 7.5 + "px";
    let isApp = new appUtil().isApp();
    if (isApp == "android" || isApp == "ios") {
      window.dhsdk.isShowNavigation({
        show: false,
      });
      window.dhsdk.onListenEvent("bindCampusPage", this.bindCampusPage);
    }
  },
  destroyed() {
    let width =
      document.documentElement.clientWidth || document.body.clientWidth;
    document.documentElement.style.fontSize = width / 10 + "px";
    window.removeEventListener("scroll", this.handleScroll, true);
  },
  mounted() {
    window.scrollTo(0, 0);
    this.changeLoading(true);
    // this.getDetailTime();
    this.getDetail();
    window.addEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    ...mapMutations({
      changeLoading: "changeLoading",
    }),
    handleScroll() {
      let _scrollTop = Math.floor(
        document.body.scrollTop ||
          document.documentElement.scrollTop ||
          window.pageXOffset
      );
      if (_scrollTop && _scrollTop > 100) {
        this.backBannerShow = true;
        this.barOpacity = _scrollTop > 200 ? 1 : (_scrollTop - 100) / 100;
      } else {
        this.backBannerShow = false;
      }
    },
    goBack() {
      window.dhsdk.finishInterface();
    },
    save() {
      console.log("qrcode_path.pic_path", this.detail.qrcode_path.pic_path);
      window.dhsdk.savePicToLocalAlbum({
        url: this.detail.qrcode_path.pic_path,
      });
    },
    editSchool() {
      let districtId =
        this.detail.districtId && this.detail.districtId != undefined
          ? this.detail.districtId
          : "";
      console.log("districtId", districtId);
      window.dhsdk.goSelectCampusPage({
        districtId, //大区的id
        campusId: this.detail.school_id, //学校的id
        source: "fromWeb",
      });
    },
    //客户端调用此方法，返回校区信息
    bindCampusPage(ojb) {
      console.log("bindCampusPage", ojb.data);
      const { campusId, campusName, campusAddress, districtId } = ojb.data;
      this.detail.districtId = districtId; //大区的id
      this.detail.school_id = campusId; //学校的id
      this.detail.school_name = campusName; //学校的名称
      this.detail.school_address = campusAddress; //学校的地址
    },
    // getDetailTime() {
    //   // 获取页面详情内容
    //   this.$api.classes
    //     .getConfig({
    //       module_alias: "parent_common_config",
    //       key: "compliance_text",
    //     })
    //     .then((res) => {
    //       this.detailTime = res.course_detail_time;
    //     });
    // },
    getDetail() {
      // 获取页面详情内容
      const { id, school_id } = this.$route.query;
      this.$api.classes.getCourseDetail({ id, school_id }).then((res) => {
        this.isloading = false;
        if (res.error_code === 0) {
          this.setDetail(res.result.data);
        } else {
          this.changeLoading(false);
          this.$toast(res.message);
        }
      });
    },
    setDetail(data) {
      this.detail_id = data.id;
      if (data.id) {
        this.detail = data;
        if (data.end_time) {
          this.detail.end_time_text = dayjs
            .unix(data.end_time / 1000)
            .format("M月D日");
        }
        if (data.start_time) {
          this.detail.start_time_text = dayjs
            .unix(data.start_time / 1000)
            .format("M月D日");
        }
        this.start_time = formatDate(data.start_time, "yyyy年MM月dd日");
        if (!data.pic_path)
          data.pic_path = require("../../assets/img/class/defaultBanner.png");
      }
      if (data.id && data.content) {
        this.renderLubanDetail();
      } else {
        this.changeLoading(false);
      }
    },
    async add() {
      // 预约成功
      if (this.isClick) {
        this.isClick = false; //防止重复点击
        let token = await getToken(); //是否登陆，未登陆先去登陆
        if (token) {
          this.changeLoading(true);
          const {
            id,
            school_id,
            course_type,
            grade_id,
            subject_id,
            city_code,
          } = this.detail;
          this.$api.classes
            .getCourseAdd({
              course_id: id,
              school_id:
                city_code == "010"
                  ? "52512019061117163919501948176"
                  : school_id,
              course_type,
              grade_id,
              subject_id: subject_id.toString(),
              city_code,
            })
            .then((res) => {
              this.isClick = true;
              this.changeLoading(false);
              if (res.error_code === 0) {
                this.$router.push({
                  path: "/appointment",
                  query: {
                    id,
                    school_id:
                      city_code == "010"
                        ? "52512019061117163919501948176"
                        : school_id,
                  },
                });
              } else if (res.error_code === 99900) {
                window.dhsdk.startLogin({
                  success: () => {
                    this.add();
                  },
                  fail: () => {},
                });
              } else {
                this.$toast(res.message);
              }
            });
        } else {
          this.isClick = true;
          window.dhsdk.startLogin({
            success: () => {
              this.add();
            },
            fail: () => {},
          });
        }
      }
    },
    openQrcode() {
      if (this.detail.qrcode_path.pic_path) {
        this.showQrcode = true;
      } else {
        this.$toast("没有该老师微信二维码");
      }
    },
    openYuyue() {
      console.log("teach_mode", this.detail.teach_mode);
      let buryName = `click_basicservice_app_coursedetail_00${
        this.detail.teach_mode === 2 ? 1 : 2
      }`;
      bury(buryName, {
        ...parmas,
        course_id: this.detail.id,
        school_id: this.detail.school_id,
        subject_name: this.detail.subject_name,
        school_name: this.detail.school_name,
      });
      this.add();
    },
    // 活动详情对接鲁班
    renderLubanDetail() {
      if (this.detail.content) {
        const host = window.location.href;
        const timestamp = formatDate(new Date(), "yyyyMMddhhss");
        let env =
          host.indexOf("/dev/") >= 0 || host.indexOf("/beta/") >= 0
            ? "luban-engine-beta"
            : "luban-engine-prod";
        var newContent = this.detail.content.replace(
          /https:\/\/static4.izhikang.com[^"]+(.png|.jpg){1}/gi,
          (match) => {
            var imgUrl = match;
            if (match.indexOf("imageMogr") === -1) {
              imgUrl = imageMogr2(match, { q: 90 });
            }
            return `${imgUrl}`;
          }
        );
        new Function(newContent)();
        loadStyle(
          `https://static1.izhikang.com/webresource/${env}/engine-assets/engine.css?timestamp=${timestamp}`
        );
        loadScript(
          `https://static1.izhikang.com/webresource/${env}/engine-assets/engine.umd.min.js?timestamp=${formatDate}`,
          () => {
            // console.log("window.engine", window.engine);
            window.engine && window.engine.default.vueInit("#h5MainPage");
          }
        );
      }
      setTimeout(() => {
        this.changeLoading(false);
      }, 1000);
    },
    serviceShowFn() {
      let { detail } = this;
      if (!detail || !detail.service_list || detail.service_list.length === 0) {
        this.$toast("暂无内容！");
        return;
      }
      this.serviceShow = true;
    },
  },
};
</script>
<style scoped lang="scss">
* {
  font-size: smaller;
}
.classBox {
  width: 100%;
  background: #ffffff;
  position: relative;
  padding-bottom: 48px;

  .backBannar {
    display: flex;
    height: 66px;
    color: #212832;
    position: fixed;
    background: #ffffff;
  }
  .classInfo {
    width: 100%;
    flex: auto;
    overflow: auto;
    position: relative;
    padding-bottom: calc(constant(safe-area-inset-bottom) - 6px);
    padding-bottom: calc(env(safe-area-inset-bottom) - 6px);

    .iconBack {
      position: absolute;
      color: #ffffff;
      font-size: 15px;
      top: 15px;
      left: 0;
      right: auto;
      padding: 10px 5px 5px 9px;
    }

    .picPath {
      width: 100%;
      height: auto;
      background: #ffffff;
      display: block;
    }

    .introduce {
      padding: 14.8px 12px 14.8px 0;
      background: #ffffff;
      .detail-title {
        padding-left: 12px;
      }
      .title {
        overflow: hidden;
        span {
          font-size: 13px;
          margin-left: -7px;
        }
        .titleCon {
          font-size: 13px;
          font-weight: bold;
          color: #000c1d;
          line-height: 20px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
        }
      }

      .subtitle {
        margin-top: 4px;
        font-size: 10px;
        line-height: 15px;
        color: #212832;
      }

      .openTime {
        margin-top: 14px;
        padding-left: 26.6px;
        background: url("../../assets/img/class/time.png") 12px center no-repeat;
        background-size: 10.3px auto;

        span {
          font-size: 10px;
          color: #5d646e;
        }
        i {
          display: inline-block;
          width: 1px;
          height: 10.3px;
          background-color: #e2e2e2;
          margin: 0 7.4px;
          position: relative;
          top: 1.5px;
        }
      }

      .tags {
        overflow: hidden;
        padding: 3px 0 0 12px;
        p {
          display: inline-block;
          font-style: normal;
          padding: 0 6px;
          margin: 4px 4.4px 0 0;
          height: 17px;
          background: #fff1df;
          border-radius: 2px;
          text-align: center;
          line-height: 17px;
          font-size: 9px;
          font-weight: bold;
          color: #a5671a;
        }
        .tags-online {
          background: #e6f3ff;
          color: #2f82d3;
        }
        .tagsli {
          display: inline-block;
          padding: 0 6px;
          height: 17px;
          margin: 4px 4.4px 0 0;
          background: #f7f8fa;
          border-radius: 2px;
          font-size: 9px;
          color: #8e959e;
          line-height: 17px;
        }
      }

      // .address {
      //   margin-top: 4px;
      //   padding-left: 26.6px;
      //   background: url("../../assets/img/class/location.png") 12px center
      //     no-repeat;
      //   background-size: 10.3px auto;
      //   font-size: 10px;
      //   color: #5d646e;
      //   display: -webkit-box;
      //   -webkit-box-orient: vertical;
      //   -webkit-line-clamp: 1;
      //   overflow: hidden;
      // }

      .qrcode {
        margin: 14.8px 0 0 12px;
        margin-left: 12px;
        padding: 0 12px;
        height: 51px;
        background: #f7f8fa;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #212832;

        .qrcodeItem {
          display: flex;
          align-items: center;

          img {
            margin-right: 7px;
            display: block;
            width: 30px;
            height: 30px;
            background: #ffffff;
            border-radius: 13px;
          }

          .title {
            font-size: 12px;
            font-weight: bold;
          }

          span {
            font-size: 9px;
          }
        }

        .btnQrcode {
          width: 57px;
          height: 21px;
          font-size: 9px;
          background: #ffffff;
          border-radius: 12px;
          text-align: center;
          line-height: 21px;
        }
      }
    }
    // 服务
    .service {
      margin: 0 12px;
      padding-right: 20px;
      border-top: 1px solid #f5f5f5;
      height: 42px;
      line-height: 42px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
      background: url("../../assets/img/class/serviceArrowright.png") right
        center no-repeat;
      background-size: 10.3px auto;
      span:first-child {
        display: inline-block;
        padding: 0 6px;
        height: 17px;
        background: rgba(224, 39, 39, 0.1);
        border-radius: 2px;
        text-align: center;
        line-height: 17px;
        font-size: 9px;
        font-weight: bold;
        color: #e02727;
        margin-right: 7.4px;
      }
      span:nth-child(2) {
        font-weight: 400;
        color: #5d646e;
        font-size: 9px;
        line-height: 40px;
      }
    }
    .content-title {
      border-top: 8px solid #f7f8fa;
      font-size: 11.8px;
      font-weight: 600;
      color: #212832;
      line-height: 41.5px;
      padding-left: 12px;
    }
  }
  .classInfo-navbar {
    padding-top: 33px;
    padding-bottom: 48px;
  }
  .classInfo-iphonex {
    padding-top: 63px;
  }
  .classInfo-notiphonex {
    padding-top: 48px;
  }
  .noneData {
    text-align: center;
    font-size: 10px;
    color: #8e959e;
    img {
      margin: 94px auto 12px auto;
      width: 170px;
      height: auto;
      display: block;
    }
  }
  .popupQrcode {
    text-align: center;
    overflow: hidden;

    .title {
      margin-top: 22px;
      font-size: 15px;
      font-weight: bold;
      color: #212832;
    }

    .subTitle {
      margin-top: 4px;
      font-size: 12px;
      color: #5d646e;
    }

    .qrcodeWeixin {
      margin: 18px auto;
      width: 160px;
      height: 160px;
      background: #fed7a7;
      border-radius: 6px;
      display: flex;

      img {
        margin: auto;
        display: block;
        width: 120px;
        height: 120px;
        background: #ffffff;
      }
    }

    .msg {
      margin-top: 7px;
      font-size: 9px;
      color: #5d646e;
    }
  }

  ::v-deep .van-popup--round {
    border-radius: 8px 8px 0 0;
  }

  ::v-deep .van-icon {
    top: 40px;
    right: 10px;
    font-size: 15px;
  }

  .btnWeixin {
    margin: 12px 15px;
    height: 42px;
    background: #e02727;
    border-radius: 21px;
    font-size: 12px;
    font-weight: bold;
    line-height: 42px;
    color: #ffffff;
    text-align: center;
  }

  .popupYuyue {
    overflow: hidden;

    .title {
      padding: 15px 27px 0 15px;
      overflow: hidden;

      i {
        display: block;
        font-style: normal;
        float: left;
        padding: 0 4px;
        margin: 4px 5px 0 0;
        height: 12px;
        background: #fff2dd;
        border-radius: 2px;
        text-align: center;
        line-height: 12px;
        font-size: 8px;
        color: #8f4d27;
      }

      .titleCon {
        font-size: 13px;
        font-weight: bold;
        color: #000c1d;
        line-height: 20px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
    }

    .classtime {
      margin: 5px 15px 0 15px;
      padding-left: 15px;
      background: url("../../assets/img/class/iconTime.png") no-repeat center
        left;
      background-size: 12px auto;
      font-size: 9px;
      line-height: 13px;
      color: #5d646e;
    }

    .addressItem {
      margin: 12px 15px 0 15px;
      display: flex;
      justify-content: space-between;
      height: 68px;
      border-radius: 6px;
      background: url("../../assets/img/class/bg00.png") no-repeat #f9fbfe
        center right;
      background-size: auto 68px;

      .value {
        margin: 12px 0 0 12px;
        color: #212832;
        font-size: 10px;
        font-weight: bold;
        line-height: 15px;

        p {
          margin-top: 5px;
          font-weight: normal;
          color: #5d646e;
          line-height: 13px;
        }
      }

      .btnCity {
        margin: 9px 9px 0 0;
        width: 70px;
        height: 21px;
        background: #ffffff;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        span {
          font-size: 9px;
          color: #5d646e;
        }

        i {
          margin-left: 3px;
          display: block;
          width: 4px;
          height: 5px;
          background: url("../../assets/img/class/iconRight.png") no-repeat;
          background-size: 100% auto;
        }
      }
    }

    .tips {
      // margin: 8px 15px;
      // padding: 0 12px;
      height: 25px;
      width: 100%;
      background: url("../../assets/img/class/iconLD.png") no-repeat #fdf7df
        right top;
      background-size: auto 25px;
      border-radius: 6px;
      font-size: 10px;
      line-height: 25px;
      color: #bb7826;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .actionBar {
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0.02rem 0px 0px #f5f5f7 inset;
    display: flex;
    align-items: center;
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 1000;
    padding-bottom: calc(constant(safe-area-inset-bottom) - 6px);
    padding-bottom: calc(env(safe-area-inset-bottom) - 6px);
    .line {
      width: 1px;
      height: 25px;
      background: #e7e8ea;
    }

    .callTel {
      display: block;
      padding: 0 15px;

      i {
        display: block;
        margin: 0 auto;
        width: 18px;
        height: 18px;
        background: url("../../assets/img/class/iconTel.png") no-repeat;
        background-size: 100% auto;
      }

      span {
        font-size: 8px;
        color: #212832;
      }
    }
    .barRight {
      flex: auto;
      padding: 6px 0;
    }

    .btnYuyue {
      float: right;
      margin-right: 10px;
      width: 184px;
      height: 36px;
      background: #e02727;
      border-radius: 18px;
      display: flex;
      align-items: center;
      justify-content: center;

      i {
        display: block;
        width: 20px;
        height: 20px;
        background: url("../../assets/img/class/iconOrder.png") no-repeat;
        background-size: 100% auto;
      }

      span {
        font-size: 12px;
        color: #ffffff;
      }
    }
  }
}
</style>
<style>
.classInfo .van-popup .van-popup__close-icon {
  top: 7px !important;
}
</style>
